var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("quote-builder-part-item-template", {
    staticClass: "pb-2 mb-2 bb-grey-1 quote-item-heading",
    class: `quote-item-heading-${_vm.$theme.name}`,
    attrs: { "is-full-width": _vm.isFullWidth },
    scopedSlots: _vm._u([
      {
        key: "description",
        fn: function () {
          return [
            _c("div", { staticClass: "is-flex is-align-items-center" }, [
              _c("span", [_vm._v(_vm._s(_vm.name))]),
              _c("span", { staticClass: "ml-2" }, [
                _vm._v("(" + _vm._s(_vm.count) + ")"),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "part_type",
        fn: function () {
          return [
            _c("div", { staticClass: "is-flex is-align-items-center mx-2" }, [
              false ? _c("span", [_vm._v("Type")]) : _vm._e(),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "report",
        fn: function () {
          return [
            _c("div", { staticClass: "is-flex is-align-items-center" }, [
              false ? _c("span", [_vm._v("Rpt")]) : _vm._e(),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "part_qty",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-align-items-center is-justify-content-end",
              },
              [_vm.count >= 1 ? _c("span", [_vm._v("Qty")]) : _vm._e()]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "part_buy",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-align-items-center is-justify-content-end",
              },
              [_vm.count >= 1 ? _c("span", [_vm._v("Buy Price")]) : _vm._e()]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "part_markup",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-align-items-center is-justify-content-end",
              },
              [_vm.count >= 1 ? _c("span", [_vm._v("Markup")]) : _vm._e()]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "part_sell",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-align-items-center is-justify-content-end",
              },
              [_vm.count >= 1 ? _c("span", [_vm._v("Unit Price")]) : _vm._e()]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "total_value",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-end is-align-items-center",
              },
              [
                _vm.count >= 1
                  ? _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$filters.formatCurrency(
                            _vm.totalAmount,
                            _vm.$userInfo.locale,
                            2
                          )
                        )
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "present_as",
        fn: function () {
          return [
            _c(
              "div",
              {
                staticClass:
                  "is-flex is-justify-content-center is-align-items-center",
              },
              [_vm.count >= 1 ? _c("span", [_vm._v("Present As")]) : _vm._e()]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }